import React, { useState } from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import api from '../../lib/api';

const validate = (values) => {
  const errors = {};
  if (!values.name.trim()) {
    errors.name = 'Name is required.';
  }
  if (!values.email.trim()) {
    errors.email = 'Email is required.';
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = 'Email is invalid.';
  }
  if (!values.message.trim()) {
    errors.message = 'Message is required.';
  }

  if (!values.subject.trim()) {
    errors.subject = 'Subject is required.';
  }

  return errors;
};

const ContactForm = () => {
  const [status, setStatus] = useState({ success: '', error: '' });

  const initialValues = {
    name: '',
    email: '',
    phoneNumber: '',
    subject: '',
    message: '',
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setStatus({ success: '', error: '' });
    try {
      const response = await api.post('/contact', values);

      if (!response.data) {
        throw new Error('Something went wrong!');
      }

      setStatus({
        success: 'Thank you for your message. We will contact you soon!',
        error: '',
      });
      resetForm();
    } catch (error) {
      setStatus({
        success: '',
        error:
          error.response?.data?.message || error.message || 'An error occurred',
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validate={validate}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
        <Form>
          <div className="row">
            <div className="col-md-6">
              <div className="form-grp">
                <Field
                  id="name"
                  type="text"
                  name="name"
                  placeholder="Your Name"
                />
                <ErrorMessage name="name" component="div" className="error" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-grp">
                <Field
                  id="email"
                  type="email"
                  name="email"
                  placeholder="Email address"
                />
                <ErrorMessage name="email" component="div" className="error" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-grp">
                <Field
                  id="phoneNumber"
                  type="text"
                  name="phoneNumber"
                  placeholder="Phone number"
                />
                <ErrorMessage
                  name="phoneNumber"
                  component="div"
                  className="error"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-grp">
                <Field
                  id="subject"
                  type="text"
                  name="subject"
                  placeholder="Subject"
                />
                <ErrorMessage
                  name="subject"
                  component="div"
                  className="error"
                />
              </div>
            </div>
          </div>
          <div className="form-grp">
            <Field
              as="textarea"
              id="message"
              name="message"
              placeholder="Write message"
            />
            <ErrorMessage name="message" component="div" className="error" />
          </div>
          {status.success && <div className="success">{status.success}</div>}
          {status.error && <div className="error">{status.error}</div>}

          <button type="submit" className="btn" disabled={isSubmitting}>
            {isSubmitting ? 'Sending...' : 'Send a message'}
          </button>
        </Form>
      )}
    </Formik>
  );
};

export default ContactForm;
//
